<!--begin::Body-->
<div class="kt-login__body">
	<!--begin::Signin-->
	<div class="kt-login__form">
		<!-- <div class="kt-login__title">
			<img src="./assets/media/logos/logoBlanco.png" alt="" style="height: 220px;">
		</div> -->

		<!-- <kt-auth-notice></kt-auth-notice> -->

		<!--begin::Form-->
		<form class="kt-form" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label style="font-family:Poppins,Helvetica,sans-serif; font-size:22px; color: #ffffff">Correo
					</mat-label>
					<input name="username" matInput type="text" autocomplete="off" [(ngModel)]="credentials.username" />
					<!--  <mat-error *ngIf="isControlHasError('email','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','email')">
						<strong>{{ 'AUTH.VALIDATION.INVALID_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','minLength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('email','maxLength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</strong>
					</mat-error>  -->
				</mat-form-field>
				<!-- <input  name="username" type="text" placeholder="Usuario:" id="inputGTM" autocomplete="off" [(ngModel)]="credentials.username"/> -->
			</div>
			<br>
			<div class="form-group">
				<mat-form-field>
					<mat-label style="font-family:Poppins,Helvetica,sans-serif; font-size:22px; color: #ffffff">
						Contraseña</mat-label>
					<input name="contraseña" matInput [type]="inputType" autocomplete="off"
						[(ngModel)]="credentials.password" />
					<!--<mat-icon style="cursor: pointer" (click)="changeTypeText()" matSuffix>remove_red_eye_icon</mat-icon>-->
					<span *ngIf="inputType == 'password'" style="cursor: pointer; color: #ffffff" (click)="changeTypeText()"
						matSuffix><i class="fas fa-eye"></i></span>
					<span *ngIf="inputType == 'text'" style="cursor: pointer; color: #ffffff" (click)="changeTypeText()" matSuffix><i
							class="fas fa-eye-slash"></i></span>
					<!-- <mat-error *ngIf="isControlHasError('password','required')">
						<strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','minLength')">
						<strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
					</mat-error>
					<mat-error *ngIf="isControlHasError('password','maxLength')">
						<strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
					</mat-error>  -->
				</mat-form-field>
				<!-- <input name="contraseña" type="password" placeholder="Contraseña:" id="inputGTM" autocomplete="off" [(ngModel)]="credentials.password"/> -->
			</div>
			<!--begin::Action-->
			<div class="kt-login__actions">
				<a href="javascript:;" routerLink="/forgot-password" class="kt-link kt-login__link-forgot"
					style="font-family:Poppins,Helvetica,sans-serif; font-size: 14px; color:#ffffff">
					{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }}
				</a>
				<button (click)="submit()"
					[ngClass]="{'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading}"
					id="kt_login_signin_submit" class="btn  btn-info btn-elevate kt-login__btn-primary">{{
					'AUTH.LOGIN.BUTTON' | translate }}</button>
			</div>
			<div class="kt-login__actions">
				<a href="javascript:;" routerLink="/registrarse" class="kt-link kt-login__link-forgot"
					style="font-family:Poppins,Helvetica,sans-serif; font-size: 14px; color:#ffffff">
					Afiliate
				</a>
			</div>
			<!--end::Action-->
		</form>
		<!--end::Form-->

	</div>
	<!--end::Signin-->
</div>
<!--end::Body-->
